import { downgradeComponent } from '@angular/upgrade/static';
import { AdminCorrectSupport } from '../../../../../../../app/shared/components/admin-correct.component';

angular
  .module('UserTrainingControllers', [])

  .directive(
    'polylearnAdminCorrectSupport',
    downgradeComponent({ component: AdminCorrectSupport })
  )

  .controller('TrainingHomeCtrl', [
    '$scope',
    '$window',
    'api',
    function($scope, $window, api) {
      $scope.currentTraining = $window.localStorage.currentTraining
        ? $window.localStorage.currentTraining
        : 'interactif';
      $scope.setCurrentTraining = function(current) {
        $window.localStorage.currentTraining = current;
      };
    }
  ])

  .controller('LessonsTrainingHomeCtrl', [
    '$scope',
    'api',
    function($scope, api) {
      api.sync(api.getLessons, function(lessons) {
        var stats = {
          known: 0,
          unknown: 0,
          inProgress: 0,
          total: lessons.length
        };

        var pLessons = [
          {
            title: 'À travailler',
            lessons: [],
            color: '#0091EA'
          },
          {
            title: "En cours d'acquisition",
            lessons: [],
            color: '#FFAB00'
          },
          {
            title: 'Acquises',
            lessons: [],
            color: '#00C853'
          }
        ];

        for (var i = 0; i < lessons.length; i++) {
          if (lessons[i].known) {
            stats.known++;
            pLessons[2].lessons.push(lessons[i]);
          } else if (lessons[i].score > 2) {
            stats.inProgress++;
            pLessons[1].lessons.push(lessons[i]);
          } else {
            stats.unknown++;
            pLessons[0].lessons.push(lessons[i]);
          }
        }
        $scope.lessons = pLessons;
      });
    }
  ])

  .controller('CleverTrainingHomeCtrl', [
    '$scope',
    'api',
    'trainingUtils',
    'exam',
    'EXAM',
    function($scope, api, trainingUtils, exam, EXAM) {
      /*********
    $scope.exercices : contains stats for part
    $scope.part : contains stats for listening and reading
    ***********/

      $scope.exercises = {};
      $scope.part = {};

      // TODO: need to be more modular !
      if (EXAM !== 'delf') {
        $scope.sections = exam.sections;
      } else {
        console.log('🔥exam', exam.sections);

        let sections = exam.sections[0];
        $scope.sections = [
          {
            id: 'reading',
            title: 'Compréhension de l’oral',
            parts: {
              B1: [sections.parts[0], sections.parts[1], sections.parts[2]],
              B2: [sections.parts[0], sections.parts[1], sections.parts[2]],
              'B1-JR': [
                sections.parts[0],
                sections.parts[1],
                sections.parts[2]
              ],
              'B2-JR': [
                sections.parts[0],
                sections.parts[1],
                sections.parts[2]
              ],
              A2: [
                sections.parts[0],
                sections.parts[1],
                sections.parts[2],
                sections.parts[3]
              ],
              'A2-JR': [
                sections.parts[0],
                sections.parts[1],
                sections.parts[2],
                sections.parts[3]
              ]
            }[api.data.me.profile.level]
          },
          {
            id: 'reading',
            title: 'Compréhension des écrits',
            parts: {
              B1: [sections.parts[3], sections.parts[4], sections.parts[5]],
              B2: [sections.parts[3], sections.parts[4], sections.parts[5]],
              'B1-JR': [
                sections.parts[3],
                sections.parts[4],
                sections.parts[5]
              ],
              'B2-JR': [
                sections.parts[3],
                sections.parts[4],
                sections.parts[5]
              ],
              A2: [
                sections.parts[4],
                sections.parts[5],
                sections.parts[6],
                sections.parts[7]
              ],
              'A2-JR': [
                sections.parts[4],
                sections.parts[5],
                sections.parts[6],
                sections.parts[7]
              ]
            }[api.data.me.profile.level]
          },
          {
            id: 'reading',
            title: 'Production orale',
            parts: {
              B1: [sections.parts[6], sections.parts[7], sections.parts[8]],
              B2: [sections.parts[6]],
              'B1-JR': [
                sections.parts[6],
                sections.parts[7],
                sections.parts[8]
              ],
              'B2-JR': [sections.parts[6]],
              A2: [sections.parts[8], sections.parts[9]],
              'A2-JR': [sections.parts[8], sections.parts[9]]
            }[api.data.me.profile.level]
          },
          {
            id: 'reading',
            title: 'Production écrite',
            parts: {
              B1: [sections.parts[9]],
              B2: [sections.parts[7]],
              'B1-JR': [sections.parts[9]],
              'B2-JR': [sections.parts[7]],
              A2: [sections.parts[10], sections.parts[11]],
              'A2-JR': [sections.parts[10], sections.parts[11]]
            }[api.data.me.profile.level]
          }
        ].map((c, index) => {
          return {
            ...c,
            id: c.id + (index + 1)
          };
        });
      }

      api.sync(api.getStats, function(data) {
        $scope.correctness = data.correctness;
        console.log(data.correctness);
      });

      $scope.toPercent = {
        bright: 60,
        toeic: 100,
        linguaskill: 104,
        lerobert: 1000,
        delf: 100
      };

      $scope.estimateScore = exam.estimatePercentScoreToGrid;

      // min percent to get Objective
      $scope.minPercent = exam.getTheMinPercentForObjective;
    }
  ])

  .controller('TrainingOnCtrl', [
    '$scope',
    '$location',
    '$mdToast',
    'audio',
    'navbar',
    'api',
    'trainingUtils',
    'exam',
    'lesson',
    'pusher',
    '$window',
    'ApiService',
    'EXAM',
    '$translate',
    function(
      $scope,
      $location,
      $mdToast,
      audio,
      navbar,
      api,
      trainingUtils,
      exam,
      lesson,
      pusher,
      $window,
      ApiService,
      EXAM,
      $translate
    ) {
      if (exam.examData.langForExercises === 'fr') {
        navbar.goBackAction(
          'Entraînement',
          '#!entrainement',
          'navbar.training'
        );
      } else {
        navbar.goBackAction('Entraînement', '#!training', 'navbar.training');
      }

      /**************
    $scope.support : contains data from GET
    $scope.data.answer : contains data of the choices user
    $scope.finished : contains data from GET
    ************/

      $scope.userAnswersInput;
      $scope.lastSavedAnswers;

      $scope.needFeedbackSubmitted = false;

      console.log('ApiService', ApiService);
      // TODO : move to directive
      $scope.noShowHelp = {};

      if ($window.localStorage.noMoreShowHelp) {
        $scope.noMoreShowHelp = JSON.parse($window.localStorage.noMoreShowHelp);
      } else {
        $scope.noMoreShowHelp = {};
      }

      $scope.setNoMoreShowHelp = function(part) {
        $scope.noMoreShowHelp[part] = true;
        $window.localStorage.noMoreShowHelp = JSON.stringify(
          $scope.noMoreShowHelp
        );
      };

      $scope.setNoShowHelp = function(part) {
        $scope.noShowHelp[part] = true;
      };

      audio.init(false, true);

      // This is for feedback
      $scope.results = {
        goodAnswers: 0,
        badAnswers: 0
      };
      $scope.training = true;
      var urlOptions = $location.search();
      $scope.lesson = urlOptions['lesson'];
      $scope.supportId = urlOptions['support']
        ? parseInt(urlOptions['support'], 10)
        : null;
      $scope.currentPart = urlOptions['part'] || [];

      if ($scope.supportId) {
        navbar.goBackAction(
          'Retour',
          '#!cours/' + $scope.lesson,
          'navbar.back'
        );
      }

      /* Lessons infos */
      api.sync(api.getLessons, function(data) {
        $scope.info = {
          known: [],
          unknown: []
        };
        for (var i = 0; i < data.length; i++) {
          if (data[i].known) {
            $scope.info.known.push(data[i].id);
          } else {
            $scope.info.unknown.push(data[i].id);
          }
        }
        $scope.lessons = data;
      });

      $scope.quickView = function(id, ev) {
        lesson.dialogDetail(id, ev);
      };

      $scope.removeLesson = function() {
        $scope.lesson = false;
        $location.search('lesson', null);
      };

      // Get data for the exam from API
      var getSupport = function() {
        $scope.loading = true;
        $scope.userAnswersInput = {};

        trainingUtils.getSupport().then(function(data) {
          $scope.support = data.support;
          if (data.support && data.support.training_audio) {
            trainingUtils.loadAudioSupport(data.support);
          }
          $scope.loading = false;
        });

        if ($scope.lesson) {
          api.getLesson($scope.lesson).then(function(data) {
            $scope.score = lesson.getPercentage(data.score);
          });
        }
      };

      $scope.init = function() {
        $scope.needFeedbackSubmitted = false;

        $scope.data = {
          answer: {}
        };
        $scope.finished = false;
        getSupport();

        if (!pusher.bind) {
          pusher.bind = true;
          pusher.channel.bind('lesson-is-known', function(data) {
            trainingUtils.lessonsToastDisplay(data.title, true);
          });
          pusher.channel.bind('lesson-is-forgotten', function(data) {
            trainingUtils.lessonsToastDisplay(data.title, false);
          });
        }
      };
      $scope.init();

      $scope.checkFinished = async function(isFinished = null, ev) {
        console.log('ev', ev);
        if (isFinished === null && EXAM !== 'delf') {
          isFinished = trainingUtils.checkFinishedSupport($scope.support);
        }
        if (isFinished) {
          $scope.finished = true;

          if ($scope.support.has_correction) {
            trainingUtils.correctAnswers($scope.support, $scope.results);
          }
          let savedAnswers = await trainingUtils.sendSupportAnswers(
            $scope.support,
            $scope.userAnswersInput
          );

          $scope.lastSavedAnswers = savedAnswers;
        }
      };

      $scope.setAnswersInput = async (question, $ev) => {
        $scope.userAnswersInput[question.id] = $ev;
        console.log('d', $scope.userAnswersInput[question.id]);
      };

      $scope.upload = async question => {
        // We assume it's this type
        // if ($scope.userAnswersInput && $scope.userAnswersInput.type) {
        // }

        const filePath = `/users/${
          api.data.me.user.id
        }/delf/${new Date().toISOString()}.mp3`;
        const upload = await ApiService.uploadFile(
          $scope.userAnswersInput[question.id],
          filePath
        );
        $scope.userAnswersInput = {
          [question.id]: upload
        };

        $scope.support.questions[0].choice_user = question.choices[0].id;
      };

      $scope.uploadAndFinished = async isFinished => {
        await $scope.upload($scope.support.questions[0]);
        $scope.checkFinished(isFinished);
      };

      $scope.checkedOpenGapAnswer = trainingUtils.checkedOpenGapAnswer;

      $scope.help = function(part, ev) {
        trainingUtils.partHelp(part, ev);
      };

      $scope.openTips = function(part, ev) {
        exam.showTips(part, ev);
      };

      $scope.updateNeedFeedback = () => {
        api.updateAnswersGQL($scope.lastSavedAnswers[0].answer.id, {
          need_feedback: true
        });
        $scope.needFeedbackSubmitted = true;

        $mdToast.show(
          $mdToast
            .simple()
            .textContent(
              $translate.instant(['toasts.sent_to_teacher'])[
                'toasts.sent_to_teacher'
              ]
            )
            .position('bottom right')
        );
      };
    }
  ]);
